/* eslint-disable */
import popupTemp from './PopUp.vue'
let Popup = {} // 定义插件对象

Popup.install = (Vue, options) => {
  let Ltemp = Vue.extend(popupTemp)
  let $vm = new Ltemp()
  let tpl = $vm.$mount().$el
  document.body.appendChild(tpl)
  Vue.prototype.$popup = {
    open: $vm.openPopup,
    close: $vm.closePopup
  }
}

export default Popup
